PJQ.collections.commitments = PJQ.collections.commitments ? PJQ.collections.commitments : {};
PJQ.models.commitments = PJQ.models.commitments ? PJQ.models.commitments : {};
PJQ.views.commitments = PJQ.views.commitments ? PJQ.views.commitments : {};

PJQ.modules.commitments = {
    routes: [
        {
            route: 'projects/:projectId/commitments',
            name: 'commitments',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments");
            }
        },
        {
            route: 'projects/:projectId/commitments/:commitmentId',
            name: 'commitment',
            callback: function (projectId, commitmentId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    commitmentId: parseInt(commitmentId)
                });
            }
        },
        {
            route: 'projects/:projectId/commitments/changeorders',
            name: 'commitmentchangeorders',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    view: 'changeorders'
                });
            }
        },
        {
            route: 'projects/:projectId/commitmentchangeorders',
            name: 'commitmentchangeorders',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    view: 'changeorders'
                });
            }
        },
        {
            route: 'projects/:projectId/commitmentchangeorders/:changeOrderId',
            name: 'commitmentchangeorder',
            callback: function (projectId, changeOrderId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    changeOrderId: parseInt(changeOrderId)
                });
            }
        },
        {
            route: 'projects/:projectId/commitments/invoices',
            name: 'payableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    view: 'invoices'
                });
            }
        },
        {
            route: 'projects/:projectId/payableinvoices',
            name: 'payableinvoices',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    view: 'invoices'
                });
            }
        },
        {
            route: 'projects/:projectId/payableinvoices/:invoiceId',
            name: 'payableinvoice',
            callback: function (projectId, invoiceId, params) {
                if (PJQ.app.session.user == null) {
                    PJQ.app.router.signInNavigate({
                        cacheRoute: true
                    });
                    return;
                }

                let parametersObject = null;
                if (params && _.size(params.trim()) > 0) {
                    parametersObject = PJQ.helpers.urlHelpers.queryStringToObject(params);
                }
                let response = parametersObject ? parametersObject.response : null;

                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "commitments", {
                    invoiceId: parseInt(invoiceId),
                    inviteResponse: response
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.commitments.routes);
